import './GlobalSearch.scss';
import fileIcon from "../../assets/Icons/file_icon.svg";
import transactionIcon from "../../assets/Icons/transaction_icon.svg";

const files_results = [
    {
        icon_path: fileIcon,
        fileName: "lorem ipsum dolor sit",
    },
    {
        icon_path: fileIcon,
        fileName: "lorem ipsum dolor sit",
    },
    {
        icon_path: fileIcon,
        fileName: "lorem ipsum dolor sit",
    },
    {
        icon_path: fileIcon,
        fileName: "lorem ipsum dolor sit",
    },
    {
        icon_path: fileIcon,
        fileName: "lorem ipsum dolor sit",
    },
    {
        icon_path: fileIcon,
        fileName: "lorem ipsum dolor sit",
    },

];
export const GlobalSearch = ({ searchIcon, partEntryIcon, batchesIcon, unitsConvertsIcon, consumibleExpandibleIcon, physicalInventoryIcon, iconViewMore, fileIcon, transactionIcon }) => {
    return (
        // <section className="global-search-component navbar-search2">
        <section className="global-search-component">
            <section className="search-inp-cont bg-white-100">
                <input
                    type="text"
                    placeholder="Search"
                // onFocus={showResultCont}
                // onBlur={hideResultCont}
                />
                <img src={searchIcon} alt="Search Icon" />
            </section>
            <section
                className={`navbar-search-results-cont bg-white ${true ? "visible" : ""
                    }`}
                id="results-cont"
            >
                <section className="all-results">
                    <div className="recent-searchs">
                        <b>Recents</b>
                        <div className="list-of-recents ">
                            <span>
                                <img
                                    src={partEntryIcon}
                                    alt=""
                                    className="bg-grey-300"
                                />
                                <p className="txt-black-mid">Part Entry</p>
                            </span>
                            <span>
                                <img
                                    src={batchesIcon}
                                    alt=""
                                    className="bg-blue-400"
                                />
                                <p className="txt-black-mid">Batches</p>
                            </span>
                            <span>
                                <img
                                    src={unitsConvertsIcon}
                                    alt=""
                                    className="bg-purple-100"
                                />
                                <p className="txt-black-mid">
                                    Units and Conversion Factors
                                </p>
                            </span>
                            <span>
                                <img
                                    src={consumibleExpandibleIcon}
                                    alt=""
                                    className="bg-orange"
                                />
                                <p className="txt-black-mid">
                                    Consumable & Expendables
                                </p>
                            </span>
                            <span>
                                <img
                                    src={physicalInventoryIcon}
                                    alt=""
                                    className="bg-blue-300"
                                />
                                <p className="txt-black-mid">Physical Inventory</p>
                            </span>
                            <span className="view-more-cont">
                                <img src={iconViewMore} alt="" />
                                <p className="txt-grey--200">View More</p>
                            </span>
                        </div>

                    </div>
                    <div className="files-results ">
                        <p className="txt-black-mid">
                            <img src={fileIcon} alt="" />
                            Files
                        </p>
                        <section className="list-files">
                            {files_results.map((file, index) => {
                                return (
                                    <span key={index} className="bg-white-100">
                                        <img src={fileIcon} alt="" />
                                        <p className="txt-black-mid">{file.fileName}</p>
                                    </span>
                                );
                            })}
                        </section>
                    </div>
                    <div className="transactions-results">
                        <h4 className="txt-black-mid">
                            <img src={transactionIcon} alt="" />
                            Transactions
                        </h4>
                        <section className="list-transactions">
                            {files_results.map((transaction, index) => {
                                return (
                                    <span key={index} className="bg-white-100">
                                        <img src={transactionIcon} alt="" />
                                        <p className="txt-black-mid">
                                            {transaction.fileName}
                                        </p>
                                    </span>
                                );
                            })}
                        </section>
                    </div>
                </section>
            </section>
        </section>
    )

}